export function getDeviceId() {
  let deviceId = localStorage.getItem("deviceId");
  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem("deviceId", deviceId);
  }
  return deviceId;
}

export function getCartKey(userId) {
  const id = userId || getDeviceId();
  return userId ? `user_cart_${id}` : `device_cart_${id}`;
}
